// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const CheckboxIndicator = createStyle({
  justifyContent: 'center',
  alignItems: 'center',
  borderColor: '$borderLight400',
  bg: '$transparent',
  borderRadius: 4,

  _web: {
    ':focusVisible': {
      outlineWidth: '2px',
      outlineColor: '$primary700',
      outlineStyle: 'solid',
      _dark: {
        outlineColor: '$primary300',
      },
    },
  },

  ':checked': {
    borderColor: '$primary500',
    bg: '$backgroundLight300',
  },

  ':hover': {
    borderColor: '$borderLight700',
    bg: '$backgroundLight100',
    ':invalid': {
      borderColor: '$error700',
    },
    ':checked': {
      bg: '$backgroundLight400',
      borderColor: '$primary600',
      ':disabled': {
        borderColor: '$primary600',
        bg: '$primary600',
        opacity: 0.4,
        ':invalid': {
          borderColor: '$error700',
        },
      },
    },
    ':disabled': {
      borderColor: '$borderLight800',
      ':invalid': {
        borderColor: '$error700',
      },
    },
  },

  ':active': {
    ':checked': {
      bg: '$backgroundLight400',
      borderColor: '$primary700',
    },
  },
  ':invalid': {
    borderColor: '$error700',
  },
  ':disabled': {
    opacity: 0.4,
  },

  _dark: {
    borderColor: '$borderDark500',
    bg: '$transparent',

    ':checked': {
      borderColor: '$primary400',
      bg: '$backgroundDark700',
    },
    ':hover': {
      borderColor: '$primary300',
      bg: '$backgroundDark800',
      ':invalid': {
        borderColor: '$error400',
      },
      ':checked': {
        bg: '$backgroundDark600',
        borderColor: '$primary300',
        ':disabled': {
          borderColor: '$primary400',
          bg: '$primary400',
          opacity: 0.4,
          ':invalid': {
            borderColor: '$error400',
          },
        },
      },
      ':disabled': {
        borderColor: '$borderDark500',
        ':invalid': {
          borderColor: '$error400',
        },
      },
    },
    ':active': {
      ':checked': {
        bg: '$backgroundDark500',
        borderColor: '$primary200',
      },
    },

    ':invalid': {
      borderColor: '$error400',
    },
    ':disabled': {
      opacity: 0.4,
    },
  },
});
